<template>
  <div>
    <!-- Blocking Disclaimer Dialog -->
    <el-dialog
      class="disclaimer-dialog"
      title=""
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :top="'2vh'"
    >
      <!-- Render the HTML for the current status -->
      <div class="message-content" v-html="currentMessage"></div>

      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" size="mini" @click="onConfirm">
            Confirm
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ShipVettingDisclaimer',
  props: {
    status: {
      type: String,
      required: true
    },
    vesselName: {
      type: String,
      default: ''
    },
    datetime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      messages: {
        // **Approved** case
        "accepted": `
          <p>Good Day,</p>
          <p><strong>1. </strong>Jurong Port Universal Terminal (the “Terminal”) provisionally accepts the vessel, <strong>${this.vesselName}</strong>, subject to the conditions set out herein.</p>
          <p><strong>2. </strong>The Terminal's provisional acceptance of the Vessel has been provided on the basis of the information provided by the customer, and the Terminal’s final acceptance is conditional and contingent on:</p>
          <ol class="sub-list">
            <li><strong>(i) </strong>our customer's continued compliance with all the terms of the relevant storage agreement(s), including but not limited to the sanctions clause;</li>
            <li><strong>(ii) </strong>the Vessel not being designated under any applicable sanctions regime and the Vessel not being employed in any activity in contravention of any applicable sanctions;</li>
            <li><strong>(iii) </strong>the Terminal's due diligence checks on the subject cargo / product, following receipt of the load port documents; and</li>
            <li><strong>(iv) </strong>the customer's assurance and warranty that the chemical composition of the cargo / product will not adversely affect the Terminal’s operations.</li>
          </ol>
          <p><strong>3. </strong>The Terminal reserves the right to require the customer to provide all relevant load port documents and Certificates of Quality of the cargo / product to be discharged, and/or hand blends of product in-tank, before permitting berthing and/or discharge.</p>
          <p><strong>4. </strong>Please also be informed that the Terminal’s provisional acceptance of the Vessel is subject to the Vessel not being designated under any applicable sanctions regime and/or being employed in any activity in contravention of any applicable sanctions. The Terminal may, in its sole discretion, conduct such checks as it may consider necessary on the Vessel, which may include (but is not limited to) checks involving Automatic Identification System (“AIS”) tracking. The customer is therefore reminded that the Vessel (and all vessels calling at the Terminal) must keep her AIS transponder on throughout the arrival and departure voyages.</p>
          <p><strong>5. </strong>Please provide us with the relevant load port documents at least three (3) days prior to berthing to facilitate the Terminal’s due diligence checks on the cargo for final acceptance.</p>
          <small>For the avoidance of doubt, the contents of this Notice and/or any checks which the Terminal may in its sole discretion conduct, do not derogate from the fact that each customer is solely and entirely responsible for the accuracy and veracity of any and all information provided to the Terminal, particularly on matters relating to the customer’s compliance with all applicable sanctions, pursuant to the sanctions clause under the relevant storage agreement(s).</small>
        `,
        // **Anchorage Inspection** case
        "anchorage inspection": `
          <p>Good Day,</p>
          <p>I refer to your request for vessel <strong>${this.vesselName}</strong> clearance and would like to draw your attention to the following:</p>
          <p><strong>1. </strong>The vessel has to be inspected at the anchorage by PacMarine. Kindly make your own arrangements and note that vessel acceptance will be subject to the outcome of the inspection.</p>
          <p><strong>2. </strong>Please note that this inspection would have to be carried out only during daylight hours.</p>
          <p class="contact-heading"><strong>CONTACT FOR PAC MARINE SINGAPORE OFFICE</strong></p>
          <p><strong>PIC:</strong> Justina Phang (Ms) Cell ph # 9009 5891</p>
          <p><strong></strong>Shaiful Bahri (Mr.) Cell ph # 9625 2366</p>
          <p><strong>Company:</strong> Pac Marine Services - Singapore</p>
          <p><strong>Tel:</strong> 65-6534 3456 (24 Hrs)</p>
          <p><strong>Fax:</strong> 65-6534 3088</p>
          <p><strong>Email:</strong> <a href="mailto:pacmarine@pacmarine.com">pacmarine@pacmarine.com</a></p>
          <p><strong>Website:</strong> <a href="https://www.pacmarine.com" target="_blank">www.pacmarine.com</a></p>
        `
      }
    };
  },
  computed: {
    // pick the right template by lower-casing the status prop
    currentMessage() {
      const key = this.status.toLowerCase();
      return this.messages[key] || '';
    }
  },
  watch: {
    // show the modal as soon as the status prop arrives (and on every change)
    status: {
      immediate: true,
      handler() {
        this.dialogVisible = true;
      }
    }
  },
  methods: {
    onConfirm() {
      this.dialogVisible = false;
      // parent will shift to the next disclaimer or close the tab
      this.$emit('disclaimer-confirmed');
    }
  }
};
</script>

<style scoped>

::v-deep .disclaimer-dialog .el-dialog__header {
  display: none; 
}

::v-deep .disclaimer-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}
.ship-vetting-menu {
  margin-bottom: 16px;
}
.message-content {
  font-size: 1.1em;       
  word-break: keep-all;
  overflow-wrap: break-word;
}

.message-content p {
  margin: 0 0 8px;        
  line-height: 1.4;
}

.message-content strong {
  font-weight: 600;
}
.sub-list {
  margin: 0 0 8px 2em;  
  line-height: 1.4;
}
.sub-list li {
  margin: 4px 0;        
}

.message-content small {  
  font-size: 0.85em;
  color: #666;
}
</style>